import administrationReducer, {defaultAdminState} from './admin/administrationReducer'
import gffReducer, {defaultGff} from './gffManager/gffReducer'
import productReducer, {defaultProducts} from './productManager/productReducer'
import scoutReducer, {defaultScout} from './scoutManager/scoutReducer'
import systemReducer, {defaultSystemState} from './systemManager/systemReducer'
import workorderReducer, {defaultWorkorder} from './workorder/workorderReducer'

import auth0Reducer from './auth0/auth0Reducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
    gff: gffReducer,
    system: systemReducer,
    product: productReducer,
    scout: scoutReducer,
    admin: administrationReducer,
    workorder: workorderReducer,
    auth0: auth0Reducer,
})

// create an object for the default data
export const defaultState = {
    gff: defaultGff,
    system: defaultSystemState,
    product: defaultProducts,
    scout: defaultScout,
    admin: defaultAdminState,
    workorder: defaultWorkorder,
}

export default rootReducer
